import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomNavbarClients from "../navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import Footer from "../Footer";
import "./PrivacyPolicy.scss";

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />
      
      <div className="privacy-container">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={10} xl={8}>
              {/* Main Title */}
              <div className="privacy-title-section">
                <h1 className="privacy-main-title">
                  Política de Privacidad
                </h1>
                <p className="privacy-subtitle">
                  Nallely Boutique - Protección y manejo de datos personales
                </p>
              </div>

              {/* Content */}
              <div className="privacy-content">
                {/* Section 1 */}
                <section className="privacy-section">
                  <h2 className="section-title">1. Información General</h2>
                  <p className="section-text">
                    En Nallely Boutique, ubicada en Av Marte R. Gómez 403, Francisco I. Madero, 87395 Heroica Matamoros, Tamaulipas, México, nos comprometemos a proteger la privacidad y los datos personales de nuestros clientes. Esta Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos su información personal de acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares de México.
                  </p>
                </section>

                {/* Section 2 */}
                <section className="privacy-section">
                  <h2 className="section-title">2. Datos Personales que Recopilamos</h2>
                  <p className="section-text">
                    Recopilamos diferentes tipos de información personal cuando interactúa con nuestros servicios:
                  </p>
                  <ul className="privacy-list">
                    <li><strong>Datos de identificación:</strong> Nombre completo, fecha de nacimiento, género</li>
                    <li><strong>Datos de contacto:</strong> Correo electrónico, número de teléfono, dirección postal</li>
                    <li><strong>Datos de entrega:</strong> Direcciones de envío, referencias de ubicación, datos del destinatario</li>
                    <li><strong>Datos de pago:</strong> Información de tarjetas de crédito/débito (procesada de forma segura por terceros)</li>
                    <li><strong>Datos de navegación:</strong> Dirección IP, tipo de navegador, páginas visitadas, tiempo de permanencia</li>
                    <li><strong>Preferencias:</strong> Historial de compras, productos favoritos, tallas preferidas</li>
                  </ul>
                </section>

                {/* Section 3 */}
                <section className="privacy-section">
                  <h2 className="section-title">3. Finalidades del Tratamiento de Datos</h2>
                  <p className="section-text">
                    Utilizamos sus datos personales para las siguientes finalidades primarias:
                  </p>
                  <ul className="privacy-list">
                    <li>Procesar y administrar sus pedidos y compras</li>
                    <li>Gestionar entregas y envíos de productos</li>
                    <li>Proporcionar atención al cliente y soporte técnico</li>
                    <li>Verificar su identidad y prevenir fraudes</li>
                    <li>Cumplir con obligaciones legales y regulatorias</li>
                    <li>Mantener registros contables y fiscales</li>
                  </ul>
                  <p className="section-text">
                    También utilizamos sus datos para finalidades secundarias (requiere su consentimiento):
                  </p>
                  <ul className="privacy-list">
                    <li>Enviar promociones, ofertas especiales y newsletter</li>
                    <li>Realizar estudios de mercado y análisis de comportamiento del consumidor</li>
                    <li>Personalizar su experiencia de compra y recomendaciones de productos</li>
                    <li>Invitaciones a eventos especiales y lanzamientos de productos</li>
                  </ul>
                </section>

                {/* Section 4 */}
                <section className="privacy-section">
                  <h2 className="section-title">4. Consentimiento y Base Legal</h2>
                  <p className="section-text">
                    Al proporcionar sus datos personales y utilizar nuestros servicios, usted otorga su consentimiento libre, específico e informado para el tratamiento de sus datos conforme a esta política. Para finalidades secundarias, solicitaremos su consentimiento expreso mediante mecanismos como casillas de verificación o confirmación por correo electrónico. Usted puede retirar su consentimiento en cualquier momento contactándonos a través de los medios indicados en esta política.
                  </p>
                </section>

                {/* Section 5 */}
                <section className="privacy-section">
                  <h2 className="section-title">5. Compartir Información con Terceros</h2>
                  <p className="section-text">
                    Nallely Boutique no vende, alquila ni comparte sus datos personales con terceros para fines comerciales. Sin embargo, podemos compartir información limitada con:
                  </p>
                  <ul className="privacy-list">
                    <li><strong>Proveedores de servicios de envío:</strong> Para gestionar entregas (DHL, FedEx, Estafeta, etc.)</li>
                    <li><strong>Procesadores de pago:</strong> Para procesar transacciones (PayPal, Mercado Pago, bancos)</li>
                    <li><strong>Proveedores de servicios tecnológicos:</strong> Para hosting, análisis web y seguridad</li>
                    <li><strong>Autoridades competentes:</strong> Cuando sea requerido por ley o orden judicial</li>
                  </ul>
                  <p className="section-text">
                    Todos estos terceros están obligados contractualmente a proteger sus datos y utilizarlos únicamente para los fines específicos acordados.
                  </p>
                </section>

                {/* Section 6 */}
                <section className="privacy-section">
                  <h2 className="section-title">6. Cookies y Tecnologías de Seguimiento</h2>
                  <p className="section-text">
                    Nuestro sitio web utiliza cookies y tecnologías similares para mejorar su experiencia de navegación:
                  </p>
                  <ul className="privacy-list">
                    <li><strong>Cookies esenciales:</strong> Necesarias para el funcionamiento básico del sitio web</li>
                    <li><strong>Cookies de rendimiento:</strong> Recopilan información sobre cómo utiliza nuestro sitio web</li>
                    <li><strong>Cookies de funcionalidad:</strong> Recuerdan sus preferencias y configuraciones</li>
                    <li><strong>Cookies publicitarias:</strong> Utilizadas para mostrar anuncios relevantes (solo con su consentimiento)</li>
                  </ul>
                  <p className="section-text">
                    Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio web. También utilizamos herramientas como Google Analytics para analizar el tráfico web, siempre respetando su privacidad.
                  </p>
                </section>

                {/* Section 7 */}
                <section className="privacy-section">
                  <h2 className="section-title">7. Seguridad de los Datos</h2>
                  <p className="section-text">
                    Implementamos medidas de seguridad técnicas, físicas y administrativas para proteger sus datos personales contra acceso no autorizado, uso indebido, alteración o destrucción:
                  </p>
                  <ul className="privacy-list">
                    <li>Encriptación SSL/TLS para transmisión de datos sensibles</li>
                    <li>Sistemas de firewall y detección de intrusiones</li>
                    <li>Acceso restringido a datos personales solo para personal autorizado</li>
                    <li>Capacitación regular del personal sobre protección de datos</li>
                    <li>Respaldos seguros y planes de recuperación de desastres</li>
                    <li>Auditorías periódicas de seguridad</li>
                  </ul>
                  <p className="section-text">
                    Sin embargo, ningún sistema es 100% seguro. Le recomendamos mantener seguras sus credenciales de acceso y notificarnos inmediatamente sobre cualquier actividad sospechosa en su cuenta.
                  </p>
                </section>

                {/* Section 8 */}
                <section className="privacy-section">
                  <h2 className="section-title">8. Retención de Datos</h2>
                  <p className="section-text">
                    Conservamos sus datos personales durante el tiempo necesario para cumplir con las finalidades descritas en esta política y cumplir con nuestras obligaciones legales:
                  </p>
                  <ul className="privacy-list">
                    <li><strong>Datos de cuenta activa:</strong> Mientras mantenga su cuenta abierta</li>
                    <li><strong>Datos de transacciones:</strong> 10 años (conforme a la legislación fiscal mexicana)</li>
                    <li><strong>Datos de marketing:</strong> Hasta que retire su consentimiento</li>
                    <li><strong>Datos de cookies:</strong> Según el tipo de cookie (de sesión hasta 24 meses)</li>
                  </ul>
                  <p className="section-text">
                    Transcurridos estos plazos, procederemos a la eliminación segura o anonimización de sus datos, salvo que exista una obligación legal que requiera su conservación por un período mayor.
                  </p>
                </section>

                {/* Section 9 */}
                <section className="privacy-section">
                  <h2 className="section-title">9. Sus Derechos como Titular de Datos</h2>
                  <p className="section-text">
                    De acuerdo con la legislación mexicana sobre protección de datos personales, usted tiene los siguientes derechos (Derechos ARCO):
                  </p>
                  <ul className="privacy-list">
                    <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre usted</li>
                    <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos</li>
                    <li><strong>Cancelación:</strong> Solicitar la eliminación de sus datos cuando no sean necesarios</li>
                    <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos para fines específicos</li>
                    <li><strong>Portabilidad:</strong> Solicitar sus datos en formato estructurado y legible</li>
                    <li><strong>Limitación:</strong> Solicitar la restricción del tratamiento en ciertos casos</li>
                  </ul>
                  <p className="section-text">
                    Para ejercer estos derechos, puede contactarnos a través del correo electrónico boutique_marte@hotmail.com. Responderemos a su solicitud en un plazo máximo de 20 días hábiles.
                  </p>
                </section>

                {/* Section 10 */}
                <section className="privacy-section">
                  <h2 className="section-title">10. Transferencias Internacionales</h2>
                  <p className="section-text">
                    Algunos de nuestros proveedores de servicios pueden estar ubicados fuera de México. En caso de transferencia internacional de datos, nos aseguramos de que el país de destino proporcione un nivel de protección adecuado o implementamos medidas de protección adicionales como:
                  </p>
                  <ul className="privacy-list">
                    <li>Cláusulas contractuales estándar de protección de datos</li>
                    <li>Certificaciones de privacidad reconocidas internacionalmente</li>
                    <li>Medidas técnicas y organizativas apropiadas</li>
                  </ul>
                </section>

                {/* Section 11 */}
                <section className="privacy-section">
                  <h2 className="section-title">11. Menores de Edad</h2>
                  <p className="section-text">
                    Nuestros servicios están dirigidos a personas mayores de 18 años. No recopilamos intencionalmente datos personales de menores de edad sin el consentimiento verificable de sus padres o tutores legales. Si identificamos que hemos recopilado datos de un menor sin la autorización correspondiente, procederemos inmediatamente a eliminar dicha información. Si usted es padre o tutor y cree que su hijo menor de edad nos ha proporcionado información personal, contáctenos de inmediato.
                  </p>
                </section>

                {/* Section 12 */}
                <section className="privacy-section">
                  <h2 className="section-title">12. Modificaciones a esta Política</h2>
                  <p className="section-text">
                    Nallely Boutique se reserva el derecho de modificar esta Política de Privacidad en cualquier momento para reflejar cambios en nuestras prácticas, servicios, o requisitos legales. Las modificaciones entrarán en vigor inmediatamente después de su publicación en nuestro sitio web. Le notificaremos sobre cambios significativos a través del correo electrónico registrado en su cuenta o mediante avisos prominentes en nuestro sitio web. Su uso continuado de nuestros servicios después de la publicación de las modificaciones constituye su aceptación de la nueva política.
                  </p>
                </section>

                {/* Section 13 */}
                <section className="privacy-section">
                  <h2 className="section-title">13. Legislación Aplicable</h2>
                  <p className="section-text">
                    Esta Política de Privacidad se rige por la legislación mexicana, específicamente por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y su Reglamento, así como por los lineamientos emitidos por el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI). Cualquier controversia relacionada con el tratamiento de sus datos personales será resuelta conforme a la legislación mexicana y ante los tribunales competentes de Heroica Matamoros, Tamaulipas.
                  </p>
                </section>

                {/* Section 14 */}
                <section className="privacy-section">
                  <h2 className="section-title">14. Contacto y Ejercicio de Derechos</h2>
                  <p className="section-text">
                    Para cualquier consulta, solicitud de información, ejercicio de derechos ARCO, o presentación de quejas relacionadas con el tratamiento de sus datos personales, puede contactarnos a través de los siguientes medios:
                  </p>
                  <ul className="contact-list">
                    <li><strong>Responsable de Datos:</strong> Nallely Boutique</li>
                    <li><strong>Correo electrónico:</strong> boutique_marte@hotmail.com</li>
                    <li><strong>Teléfono:</strong> 868 265 3942</li>
                    <li><strong>Dirección:</strong> Av Marte R. Gómez 403, Francisco I. Madero, 87395 Heroica Matamoros, Tamps.</li>
                    <li><strong>Horario de atención:</strong> Lunes a Sábado de 10:00 a.m. a 7:00 p.m.</li>
                    <li><strong>Asunto:</strong> Para consultas por correo, favor de indicar "DATOS PERSONALES" en el asunto</li>
                  </ul>
                  <p className="section-text">
                    Para el ejercicio de sus derechos ARCO, deberá proporcionar la siguiente documentación:
                  </p>
                  <ul className="privacy-list">
                    <li>Solicitud por escrito especificando el derecho que desea ejercer</li>
                    <li>Copia de identificación oficial vigente</li>
                    <li>Descripción clara de los datos sobre los que busca ejercer el derecho</li>
                    <li>Cualquier documento que facilite la localización de sus datos</li>
                  </ul>
                </section>

                {/* Section 15 */}
                <section className="privacy-section">
                  <h2 className="section-title">15. Compromiso de Privacidad</h2>
                  <p className="section-text">
                    En Nallely Boutique nos comprometemos a mantener la confidencialidad, integridad y disponibilidad de sus datos personales. Implementamos las mejores prácticas en materia de protección de datos y nos mantenemos actualizados sobre las mejores tecnologías y procedimientos de seguridad. Su confianza es fundamental para nosotros, y trabajamos constantemente para merecerla y mantenerla.
                  </p>
                  <p className="section-text">
                    Capacitamos regularmente a nuestro personal sobre la importancia de la protección de datos personales y las responsabilidades que esto conlleva. Realizamos auditorías periódicas para asegurar el cumplimiento de esta política y de la legislación aplicable.
                  </p>
                </section>

                {/* Footer info */}
                <div className="privacy-footer">
                  <p className="last-updated">
                    <strong>Última actualización:</strong> Julio 2025
                  </p>
                  <p className="effective-date">
                    Esta Política de Privacidad es efectiva a partir de la fecha de su publicación y permanecerá vigente hasta que sea modificada conforme a los términos aquí establecidos.
                  </p>
                  <p className="acknowledgment">
                    <strong>Reconocimiento:</strong> Al utilizar nuestros servicios, usted reconoce que ha leído, entendido y acepta las prácticas descritas en esta Política de Privacidad.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      
      <Footer />
    </>
  );
};

export default PrivacyPolicy;